<template>
  <li class="sr_process_item">
    <div class="sr_process_item__tail"></div>
    <div
      v-if="!$slots.dot"
      class="sr_process_item__node"
      :style="{
        backgroundColor: backgroundColor
      }"
    >
      <img v-if="icon" class="sr_process_item__icon" :src="icon" />
      <span v-else>{{ operateName.substr(-2) }}</span>
    </div>
    <div v-if="$slots.dot" class="sr_process_item__dot">
      <slot name="dot"></slot>
    </div>
    <div class="sr_process_item__wrapper">
      <div class="sr_process_item__time">
        <div class="operate_name">{{ operateName }}</div>
        <div class="operate_time">{{ timestamp }}</div>
      </div>
      <slot name="tip">{{ tip }}</slot>
      <ul
        class="sr_process_item__notice"
        v-if="sendPerson && sendPerson.length"
      >
        <li v-for="(item, index) in sendPerson" :key="index">
          <img :src="item.profile" />
          <span>{{ item.name }}</span>
        </li>
        <!-- <i class="el-icon-caret-bottom"></i> -->
      </ul>
      <div
        class="sr_process_item__status"
        :style="{
          color: statusColor
        }"
        v-else
      >
        {{ statusText }}
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "SrProcessItem",

  props: {
    /**
     * 操作时间
     */
    timestamp: String,

    /**
     * 头像或者姓名的背景色
     */
    backgroundColor: String,

    /**
     * 操作人的头像
     */
    icon: String,

    /**
     * 抄送人数组
     */
    sendPerson: Array,

    /**
     * 操作人姓名
     */
    operateName: String,

    /**
     * 状态文案
     */
    statusText: String,

    /**
     * 状态文案的颜色
     */
    statusColor: String
  },

  components: {},

  data() {
    return {};
  },

  mounted() {
    this.onLoad();
  },

  methods: {
    onLoad() {}
  }
};
</script>


// WEBPACK FOOTER //
// packages/SrProcessItem/index.vue